/* Rince — nieuwsbrief-aanmelding via de Klaviyo Client API.
   Gedeeld door de balk- en pagina-sectie. Delegation op document-niveau,
   dus meerdere formulieren per pagina en theme-editor-rerenders zijn geen
   probleem. Alleen de publieke Site ID wordt gebruikt, nooit de private key.

   TWEE AANROEPEN, BEWUST GESCHEIDEN
   1. client/profiles  -> schrijft e-mailadres, locatie en alle custom
      properties. Dit is de enige route die properties bewaart: het
      subscriptions-endpoint documenteert alleen email, phone_number en
      subscriptions, en liet custom properties in de praktijk vallen.
   2. client/subscriptions -> regelt de aanmelding zelf (consent). Alleen
      wanneer er een lijst-ID is ingesteld.
   Daarna volgt het event 'Nieuwsbrief aanmelding', dat je segment vult en
   als flow-trigger dient.

   Segmenten worden niet vanaf de website aangemaakt: dat kan de Client API
   niet en het hoort niet in een storefront-script. Segmenten die op dit
   event of op deze velden filteren, vullen zichzelf. */
(function () {
  'use strict';
  if (window.__rxNewsletterInit) return;
  window.__rxNewsletterInit = true;

  var REV = '2024-10-15';
  var dataPromise = null;

  function kv(key, path, data) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REV },
      body: JSON.stringify({ data: data })
    });
  }

  function flash(form, text, isError) {
    var m = form.querySelector('[data-rx-nl-msg]');
    if (!m) return;
    m.hidden = false;
    m.textContent = text;
    m.classList.toggle('is-error', !!isError);
  }

  /* zelfde indeling als de waterchecker op de site */
  function classify(avg) {
    if (avg >= 12) return ['hard', 'Zeer hard'];
    if (avg >= 8) return ['hard', 'Hard'];
    if (avg >= 6) return ['medium', 'Gemiddeld'];
    if (avg >= 4) return ['soft', 'Zacht'];
    return ['soft', 'Zeer zacht'];
  }

  function loadData(url) {
    if (!url) return Promise.resolve(null);
    if (!dataPromise) dataPromise = fetch(url).then(function (r) { return r.json(); }).catch(function () { return null; });
    return dataPromise;
  }

  /* Het gekozen land uit het formulier. Standaard Nederland, zodat een
     formulier zonder landkeuze zich blijft gedragen zoals voorheen. */
  function landOf(form) {
    var sel = form && form.querySelector('select[name="land"]');
    return sel && sel.value === 'BE' ? 'BE' : 'NL';
  }

  /* postcode -> water_* velden. Resolvet naar null als er niets te vinden is.
     `land` is leidend: 3000 is Leuven in België en Rotterdam in Nederland, dus
     zonder die keuze zou de helft van de aanmeldingen in het verkeerde land
     terechtkomen. Alleen als het gekozen land de postcode niet kent kijken we
     alsnog in het andere; een verkeerd land is dan waarschijnlijker dan een
     verzonnen postcode. */
  function waterFor(zip, dataUrl, land) {
    var pc = String(zip || '').replace(/\s/g, '').slice(0, 4);
    if (!/^\d{4}$/.test(pc)) return Promise.resolve(null);
    return loadData(dataUrl).then(function (d) {
      if (!d) return null;
      var min, max, city, country;

      function tryBE() {
        if (!d.be || !d.be[pc]) return false;
        min = max = d.be[pc][0]; city = d.be[pc][1]; country = 'BE';
        return true;
      }
      function tryNL() {
        var n = parseInt(pc, 10);
        for (var i = 0; i < d.nl.length; i++) {
          var r = d.nl[i];
          if (n >= r[0] && n <= r[1]) { min = r[2]; max = r[3]; city = r[4]; country = 'NL'; return true; }
        }
        return false;
      }

      if (land === 'BE') { if (!tryBE()) tryNL(); }
      else { if (!tryNL()) tryBE(); }

      if (min === undefined) return null;
      var avg = min === max ? min : Math.round((min + max) / 2 * 10) / 10;
      var c = classify(avg);
      return {
        water_city: city, water_postcode: pc, water_country: country,
        water_hardness_dh_min: min, water_hardness_dh_max: max, water_hardness_avg: avg,
        water_category: c[0], water_label: c[1], water_source: 'nieuwsbrief',
        water_checked_at: new Date().toISOString()
      };
    });
  }

  /* ── live herkenning tijdens het typen ─────────────────────────────────
     Zodra vier cijfers zijn ingevuld tonen we plaats en waterhardheid, net
     als de waterchecker. Dat maakt meteen duidelijk wat er verwacht wordt. */
  var LAND_NAAM = { NL: 'Nederlandse', BE: 'Belgische' };

  function updateZipHint(form) {
    var el = form.querySelector('input[name="zip"]');
    var hint = form.querySelector('[data-rx-nl-zip-hint]');
    if (!el || !hint) return;

    var pc = (el.value || '').replace(/\D/g, '').slice(0, 4);
    if (el.value !== pc) el.value = pc;          // alleen cijfers toelaten

    if (pc.length < 4) {
      hint.textContent = '';
      hint.classList.remove('is-error');
      form.dataset.zipCountry = '';
      return;
    }
    var land = landOf(form);
    waterFor(pc, form.dataset.waterData, land).then(function (w) {
      if (!w) {
        hint.textContent = 'Deze postcode kennen we niet. Klopt hij?';
        hint.classList.add('is-error');
        form.dataset.zipCountry = '';
        return;
      }
      var tekst = w.water_city + ' · ' + w.water_label.toLowerCase() + ' water';
      // Gevonden in het andere land: zeg dat, dan kan de bezoeker het rechtzetten.
      if (w.water_country !== land) {
        tekst += '. Dit is een ' + LAND_NAAM[w.water_country] + ' postcode.';
      }
      hint.textContent = tekst;
      hint.classList.remove('is-error');
      form.dataset.zipCountry = w.water_country;
    });
  }

  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('input[name="zip"]')) return;
    var form = el.closest('[data-rx-newsletter]');
    if (form) updateZipHint(form);
  });

  // Land wisselen zoekt de al ingevulde postcode meteen opnieuw op.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('select[name="land"]')) return;
    var form = el.closest('[data-rx-newsletter]');
    if (form) updateZipHint(form);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-rx-newsletter]');
    if (!form) return;
    e.preventDefault();

    var key = (form.dataset.key || '').trim();
    var list = (form.dataset.list || '').trim();
    var source = form.dataset.source || 'Nieuwsbrief';
    var dataUrl = form.dataset.waterData || '';
    var discount = form.dataset.discount === 'true';
    var emailEl = form.querySelector('input[type="email"]');
    var zipEl = form.querySelector('input[name="zip"]');
    var hp = form.querySelector('input[name="website"]');
    var btn = form.querySelector('button[type="submit"]');
    var email = emailEl ? (emailEl.value || '').trim() : '';
    var zip = zipEl ? (zipEl.value || '').replace(/\D/g, '').slice(0, 4) : '';
    var land = landOf(form);

    // honeypot gevuld: stil "slagen" zonder iets te versturen
    if (hp && hp.value) { flash(form, form.dataset.success || 'Gelukt.'); return; }

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      flash(form, 'Vul een geldig e-mailadres in.', true);
      return;
    }
    if (zip && zip.length !== 4) {
      flash(form, 'Een postcode heeft vier cijfers, bijvoorbeeld 1012.', true);
      return;
    }
    if (!key) {
      flash(form, 'De aanmelding staat nog niet aan. Probeer het later opnieuw.', true);
      return;
    }

    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    waterFor(zip, dataUrl, land).then(function (water) {
      // profielvelden: hiermee definieer je de segmenten in Klaviyo
      var props = {
        nieuwsbrief_aangemeld: true,
        nieuwsbrief_aanmelddatum: new Date().toISOString(),
        nieuwsbrief_bron: source,
        nieuwsbrief_pagina: location.pathname,
        welkomstkorting_beloofd: discount
      };
      // Het gekozen land is er ook zonder postcode: daarmee kun je altijd
      // op NL of BE segmenteren, ook bij een lege postcode.
      if (zipEl) props.land = land;
      if (water) for (var k in water) props[k] = water[k];

      var profileAttrs = { email: email, properties: props };
      if (water) profileAttrs.location = { zip: water.water_postcode, city: water.water_city, country: water.water_country };
      else if (zip) profileAttrs.location = { zip: zip, country: land };
      else if (zipEl) profileAttrs.location = { country: land };

      // 1. profiel met properties (de enige route die properties bewaart)
      return kv(key, 'profiles', { type: 'profile', attributes: profileAttrs })
        .then(function (r) {
          if (!r.ok && r.status !== 409) throw new Error('profiel ' + r.status); // 409 = bestaat al
          // 2. aanmelding zelf, alleen met een lijst-ID
          if (!list) return { ok: true };
          // Zonder het expliciete subscriptions-blok legt Klaviyo geen
          // marketingtoestemming vast: het profiel komt er dan wel, maar blijft
          // op "Never subscribed" staan en valt buiten je lijst.
          return kv(key, 'subscriptions', {
            type: 'subscription',
            attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: {
              email: email,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } } },
            relationships: { list: { data: { type: 'list', id: list } } }
          });
        })
        .then(function (r) {
          if (r && r.ok === false && r.status !== 409) throw new Error('aanmelding ' + r.status);

          // 3. event: vult je segment en is direct bruikbaar als flow-trigger
          var evProps = {
            bron: source,
            lijst: list || 'geen lijst',
            pagina: location.pathname,
            postcode: zip || null,
            land: zipEl ? land : null,
            heeft_postcode: !!zip,
            welkomstkorting_beloofd: discount
          };
          if (water) {
            evProps.water_category = water.water_category;
            evProps.water_label = water.water_label;
            evProps.water_city = water.water_city;
            evProps.water_country = water.water_country;
          }
          kv(key, 'events', {
            type: 'event',
            attributes: {
              properties: evProps,
              metric: { data: { type: 'metric', attributes: { name: 'Nieuwsbrief aanmelding' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }).catch(function () { /* stil: de aanmelding zelf is al gelukt */ });

          form.querySelectorAll('.rx-nl__row, .rx-nlp__row, .rx-nl__privacy, .rx-nlp__privacy, [data-rx-nl-zip-hint]').forEach(function (el) { el.style.display = 'none'; });
          flash(form, form.dataset.success || 'Gelukt. Check je inbox om je aanmelding te bevestigen.');
        });
    })
      .catch(function () {
        flash(form, 'Aanmelden lukte even niet. Probeer het later opnieuw.', true);
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
  });
})();
